/* eslint-disable */
/**
 * method命名规则
 * 取url中个性命名部分，使用大写驼峰进行组合，禁止个性化自定义名称，避免该配置文件丢失后，无法找回使用的方法名
 * 如：/api/v1/basic/data，/api/v1/为公共部分，取basic/data组成 BasicData
 */
module.exports = {
  apiConfig: [
    {
      name: 'token获取',
      method: 'Token',
      url: '/bus/api/v1/token',
      type: 'post'
    },
    {
      name: 'token刷新',
      method: 'TokenRefresh',
      url: '/bus/api/v1/token/refresh',
      type: 'get'
    },
    {
      name: '扫码登录',
      method: 'TokenScan',
      url: '/api/v1/token/scan',
      type: 'get'
    },
    {
      name: '企业微信登录',
      method: 'TokenWechatWork',
      url: '/bus/api/v1/token/wechat/work',
      type: 'get'
    },
    {
      name: '获取验证码',
      method: 'Captcha',
      url: '/bus/api/v1/captcha',
      type: 'get'
    },
    {
      name: '验证验证码',
      method: 'CaptchaVerify',
      url: '/bus/api/v1/captcha/verify',
      type: 'get'
    },
    {
      name: '文件上传',
      method: 'FileUpload',
      url: '/bus/api/v1/file/upload',
      type: 'post'
    },
    {
      name: '获取当前用户信息',
      method: 'UserCurrent',
      url: '/bus/api/v1/user/current',
      type: 'get'
    },
    {
      name: '当前用户信息-增删改',
      method: 'User',
      url: '/bus/api/v1/user',
      type: 'put'
    },
    {
      name: '所有子系统信息-增删改查',
      method: 'System',
      url: '/bus/api/v1/system',
      type: 'get'
    },
    {
      name: '子系统详细信息',
      method: 'SystemInfo',
      url: '/bus/api/v1/system/info',
      type: 'get'
    },
    {
      name: '获取菜单列表',
      method: 'Menu',
      url: '/bus/api/v1/menu',
      type: 'get'
    },
    {
      name: '用户角色',
      method: 'Role',
      url: '/bus/api/v1/role',
      type: 'get'
    },
    {
      name: '用户角色详情',
      method: 'RoleDetail',
      url: '/bus/api/v1/role/detail',
      type: 'get'
    },
    {
      name: '获取该角色下有哪些用户',
      method: 'RoleUser',
      url: '/bus/api/v1/role/user',
      type: 'get'
    },
    {
      name: '给用户分配角色',
      method: 'RoleRelation',
      url: '/bus/api/v1/role/relation',
      type: 'post'
    },
    {
      name: '获取行政区划',
      method: 'Area',
      url: '/bus/api/v1/area',
      type: 'get'
    },
    {
      name: '搜索行政区划',
      method: 'AreaSearch',
      url: '/bus/api/v1/area/search',
      type: 'get'
    },
    {
      name: '获取角色权限分配菜单树',
      method: 'PowerAuthRole',
      url: '/bus/api/v1/power/auth/role',
      type: 'get'
    },
    {
      name: '获取日志',
      method: 'LogPaging',
      url: '/bus/api/v1/log/paging',
      type: 'post'
    },
    {
      name: '获取组织架构信息',
      method: 'DepartmentTree',
      url: '/bus/api/v1/department/tree',
      type: 'get'
    },
    {
      name: '获取组织架构下用户列表',
      method: 'UserTree',
      url: '/bus/api/v1/user/tree',
      type: 'get'
    },
    {
      name: '获取用户维数据',
      method: 'UserDim',
      url: '/bus/api/v1/user/dim',
      type: 'get'
    },
    {
      name: '获取用户详细信息',
      method: 'UserDetail',
      url: '/bus/api/v1/user/detail',
      type: 'get'
    },
    {
      name: '验证账号是否可用',
      method: 'UserVerify',
      url: '/bus/api/v1/user/verify',
      type: 'get'
    },
    {
      name: '获取权限分配菜单树',
      method: 'PowerAuthUser',
      url: '/bus/api/v1/power/auth/user'
    },
    {
      name: '修改用户密码',
      method: 'UserCode',
      url: '/bus/api/v1/user/code',
      type: 'put'
    },
    {
      name: '用户修改密码',
      method: 'UserCodeReset',
      url: '/bus/api/v1/user/code/reset',
      type: 'put'
    },
    {
      name: '修改用户账号激活状态',
      method: 'UserStatus',
      url: '/bus/api/v1/user/status',
      type: 'put'
    },
    {
      name: '获取组织架构下组织列表（组织管理表格列表）',
      method: 'DepartmentForm',
      url: '/bus/api/v1/department/form',
      type: 'get'
    },
    {
      name: '获取组织详细信息',
      method: 'DepartmentDetail',
      url: '/bus/api/v1/department/detail',
      type: 'get'
    },
    {
      name: '获取行政区划详情',
      method: 'AreaDetail',
      url: '/bus/api/v1/area/detail',
      type: 'get'
    },
    {
      name: '组织信息相关',
      method: 'Department',
      url: '/bus/api/v1/department'
    },
    {
      name: '获取菜单详情',
      method: 'MenuDetail',
      url: '/bus/api/v1/menu/detail',
      type: 'get'
    },
    {
      name: '修改菜单是否默认加载',
      method: 'MenuIsdefault',
      url: '/bus/api/v1/menu/isdefault',
      type: 'put'
    },
    {
      name: '修改菜单是否启用',
      method: 'MenuIsenabled',
      url: '/bus/api/v1/menu/isenabled',
      type: 'put'
    },
    {
      name: '根据sign获取相应的枚举',
      method: 'Enum',
      url: '/bus/api/v1/enum',
      type: 'get'
    },
    {
      name: '获取组织关联用户',
      method: 'DepartmentUser',
      url: '/bus/api/v1/department/user',
      type: 'get'
    },
    {
      name: '获取当前系统下的组织机构和人员',
      method: 'DepartmentUserSystem',
      url: '/bus/api/v1/department/user/system',
      type: 'get'
    },
    {
      name: '设置组织关联用户',
      method: 'RelateDepartment',
      url: '/bus/api/v1/user/relate/department',
      type: 'put'
    },
    {
      name: '获取菜单授权码',
      method: 'MenuAuthorizeCode',
      url: '/bus/api/v1/menu/authorize/code',
      type: 'get'
    },
    {
      name: '菜单维数据',
      method: 'MenuDim',
      url: '/bus/api/v1/menu/dim',
      type: 'get'
    },
    {
      name: '获取用户已经授予的数据权限',
      method: 'PowerAuthorizedUser',
      url: '/bus/api/v1/data/power/authorized/user',
      type: 'get'
    },
    {
      name: '获取角色已经授予的数据权限',
      method: 'PowerAuthorizedRole',
      url: '/bus/api/v1/data/power/authorized/role',
      type: 'get'
    },
    {
      name: '设置用户的数据权限',
      method: 'DataPowerAuthUser',
      url: '/bus/api/v1/data/power/auth/user',
      type: 'post'
    },
    {
      name: '设置角色的数据权限',
      method: 'DataPowerAuthRole',
      url: '/bus/api/v1/data/power/auth/role',
      type: 'post'
    },
    {
      name: '获取用户已经授予的字段权限',
      method: 'FieldAuthorizedUser',
      url: '/bus/api/v1/field/authorized/user',
      type: 'get'
    },
    {
      name: '获取角色已经授予的字段权限',
      method: 'FieldAuthorizedRole',
      url: '/bus/api/v1/field/authorized/role',
      type: 'get'
    },
    {
      name: '设置用户的字段权限',
      method: 'FieldPowerUser',
      url: '/bus/api/v1/field/power/user',
      type: 'post'
    },
    {
      name: '设置角色的字段权限',
      method: 'FieldPowerrRole',
      url: '/bus/api/v1/field/power/role',
      type: 'post'
    },
    {
      name: '获取服务器信息',
      method: 'Monitor',
      url: '/bus/api/v1/monitor',
      type: 'get'
    },
    {
      name: '获取指定菜单数据权限规则',
      method: 'FilterRulelist',
      url: '/bus/api/v1/filter/rule/list',
      type: 'post'
    },
    {
      name: '获取指定菜单数据权限规则/增删改',
      method: 'FilterRule',
      url: '/bus/api/v1/filter/rule',
      type: 'get'
    },
    {
      name: '获取系统下前台用户的权限',
      method: 'PowerUser',
      url: '/bus/api/v1/power/user',
      type: 'get'
    },
    {
      name: '获取用户字段权限',
      method: 'Field',
      url: '/bus/api/v1/field',
      type: 'get'
    },
    {
      name: '获取字典分页数据',
      method: 'EnumPaging',
      url: '/bus/api/v1/enum/paging',
      type: 'post'
    },
    {
      name: '获取字典分页数据',
      method: 'EnumTree',
      url: '/bus/api/v1/enum/tree',
      type: 'post'
    },
    {
      name: '根据枚举id获取枚举信息',
      method: 'EnumSingle',
      url: '/bus/api/v1/enum/single',
      type: 'get'
    },
    {
      name: '获取分组标识信息',
      method: 'EnumSign',
      url: '/bus/api/v1/enum/sign',
      type: 'get'
    },
    {
      name: '更新分组标识名称',
      method: 'EnumSignName',
      url: '/bus/api/v1/enum/sign/name',
      type: 'put'
    },
    {
      name: '修改枚举是否选中',
      method: 'EnumChecked',
      url: '/bus/api/v1/enum/checked',
      type: 'put'
    },
    {
      name: '修改枚举是否默认',
      method: 'EnumDefaulted',
      url: '/bus/api/v1/enum/defaulted',
      type: 'put'
    },
    {
      name: '修改枚举是否启用',
      method: 'EnumEnabled',
      url: '/bus/api/v1/enum/enabled',
      type: 'put'
    },
    {
      name: '数据源--添加',
      method: 'Conn',
      url: '/bus/api/v1/conn',
      type: 'post'
    },
    {
      name: '数据源--获取所有连接串',
      method: 'ConnAll',
      url: '/bus/api/v1/conn/all',
      type: 'get'
    },
    {
      name: '获取当前系统的连接串',
      method: 'ConnSystem',
      url: '/bus/api/v1/conn/system',
      type: 'get'
    },
    {
      name: '获取当前系统下的表',
      method: 'ConnTables',
      url: '/bus/api/v1/conn/tables',
      type: 'post'
    },
    {
      name: '获取当前系统下表的字段信息',
      method: 'ConnTableColumns',
      url: '/bus/api/v1/conn/table/columns',
      type: 'post'
    },
    {
      name: '生成mapper文件',
      method: 'ConnMapper',
      url: '/bus/api/v1/conn/mapper',
      type: 'get'
    },
    {
      name: '通用接口',
      method: 'BasicData',
      url: '/bus/api/v1/basic/data',
      type: 'get'
    },
    {
      name: '文件-创建文件夹',
      method: 'FileStorageCreateDirectory',
      url: '/bus/api/v1/file/storage/create/directory',
      type: 'post'
    },
    {
      name: '文件-下载文件',
      method: 'FileStorageDownload',
      url: '/bus/api/v1/file/storage/download',
      type: 'post'
    },
    {
      name: '文件-移动资源（文件、文件夹）',
      method: 'FileStorageMove',
      url: '/bus/api/v1/file/storage/move',
      type: 'post'
    },
    {
      name: '文件-删除资源（文件、文件夹）',
      method: 'FileStorageRemove',
      url: '/bus/api/v1/file/storage/remove',
      type: 'post'
    },
    {
      name: '文件-资源（文件、文件夹）重命名',
      method: 'FileStorageRename',
      url: '/bus/api/v1/file/storage/rename',
      type: 'post'
    },
    {
      name: '文件-查询资源目录',
      method: 'FileStorageSearch',
      url: '/bus/api/v1/file/storage/search',
      type: 'post'
    },
    {
      name: '文件-上传文件',
      method: 'FileStorageUpload',
      url: '/bus/api/v1/file/storage/upload',
      type: 'post'
    },
    {
      name: '资源成员文档权限-变更成员权限、获取资源成员权限',
      method: 'FilePermission',
      url: '/bus/api/v1/file/permission',
      type: 'put'
    },
    {
      name: '资源成员文档权限-获取当前用户拥有的权限',
      method: 'FilePermissionUser',
      url: '/bus/api/v1/file/permission/user',
      type: 'get'
    },
    {
      name: '文件存储分类信息-添加、删除',
      method: 'FileCategory',
      url: '/bus/api/v1/file/category',
      type: 'post'
    },
    {
      name: '文件存储分类信息-分类排序',
      method: 'FileCategorySort',
      url: '/bus/api/v1/file/category/sort',
      type: 'put'
    },
    {
      name: '文件存储分类信息-获取用户可见分类',
      method: 'FileCategoryList',
      url: '/bus/api/v1/file/category/list',
      type: 'post'
    },
    {
      name: '文件存储分类信息-分类重命名',
      method: 'FileCategoryRename',
      url: '/bus/api/v1/file/category/rename',
      type: 'put'
    },
    {
      name: '分类成员-添加、删除、获取分类成员',
      method: 'FileCategoryMember',
      url: '/bus/api/v1/file/category/member',
      type: 'post'
    },
    {
      name: '分类成员-获取当前用户拥有的分类权限',
      method: 'FileCategoryMemberPermission',
      url: '/bus/api/v1/file/category/member/permission',
      type: 'put'
    },
    {
      name: '分类成员-变更成员角色',
      method: 'FileCategoryMemberRole',
      url: '/bus/api/v1/file/category/member/role',
      type: 'put'
    },
    {
      name: '分类成员-转让管理员',
      method: 'FileCategoryMemberTransferManager',
      url: '/bus/api/v1/file/category/member/transfer/manager',
      type: 'put'
    },
    {
      name: '文件存储角色信息-获取角色信息',
      method: 'FileRole',
      url: '/bus/api/v1/file/role',
      type: 'get'
    },
    {
      name: '意见反馈',
      method: 'UserFeedback',
      url: '/bus/api/v1/user/feedback',
      type: 'post'
    },
    {
      name: '意见反馈查询',
      method: 'UserFeedbackPaging',
      url: '/bus/api/v1/user/feedback/paging',
      type: 'post'
    },
    {
      name: '意见反馈查询',
      method: 'UserFeedbackReply',
      url: '/bus/api/v1/user/feedback/reply',
      type: 'post'
    },
    {
      name: '获取所有消息',
      method: 'MessageAll',
      url: '/bus/api/v1/message/all',
      type: 'get'
    },
    {
      name: '获取系统未读消息',
      method: 'MessageSystemUnread',
      url: '/bus/api/v1/message/system/unread',
      type: 'get'
    },
    {
      name: '获取未读消息',
      method: 'MessageUnread',
      url: '/bus/api/v1/message/unread',
      type: 'get'
    },
    {
      name: '获取未读消息',
      method: 'MessageRead',
      url: '/bus/api/v1/message/read',
      type: 'put'
    },
    {
      name: '获取未读消息数量',
      method: 'MessageUnreadNumber',
      url: '/bus/api/v1/message/unread/number',
      type: 'get'
    },
    {
      name: '获取角色下拉框信息',
      method: 'RoleEnum',
      url: '/bus/api/v1/role/enum',
      type: 'get'
    },
    {
      name: '添加链接（增删改）',
      method: 'SysLinks',
      url: '/bus/api/v1/links',
      type: 'post'
    },
    {
      name: '查询链接',
      method: 'SysLinksPaging',
      url: '/bus/api/v1/links/paging',
      type: 'post'
    },
    {
      name: '获取已有分类',
      method: 'SysLinksCategory',
      url: '/bus/api/v1/links/category',
      type: 'get'
    },
    {
      name: '获取已有分类2',
      method: 'LinksCategoryList',
      url: '/bus/api/v1/links/category/list',
      type: 'get'
    },
    {
      name: '修改菜单排序',
      method: 'MenuSort',
      url: '/bus/api/v1/menu/sort',
      type: 'put'
    },
    {
      name: '获取栏目树形信息',
      method: 'CmsCategoryTree',
      url: '/bus/api/v1/cms/category/tree',
      type: 'get'
    },
    {
      name: '获取栏目排序',
      method: 'CmsCategorySort',
      url: '/bus/api/v1/cms/category/sort',
      type: 'put'
    },
    {
      name: '分页获取栏目信息',
      method: 'CmsCategoryList',
      url: '/bus/api/v1/cms/category/list',
      type: 'post'
    },
    {
      name: '根据栏目ID获取栏目信息',
      method: 'CmsCategory',
      url: '/bus/api/v1/cms/category',
      type: 'post'
    },
    {
      name: '分页获取内容',
      method: 'ContentPaging',
      url: '/bus/api/v1/cms/content/paging',
      type: 'post'
    },
    {
      name: '添加内容',
      method: 'CmsContent',
      url: '/bus/api/v1/cms/content',
      type: 'post'
    },
    {
      name: '内容审核，需要audit权限',
      method: 'CmsContentAudit',
      url: '/bus/api/v1/cms/content/audit',
      type: 'put'
    },
    {
      name: '获取系统主站信息',
      method: 'SiteSystem',
      url: '/bus/api/v1/site/system',
      type: 'get'
    },
    {
      name: '添加系统主站信息',
      method: 'Site',
      url: '/bus/api/v1/site',
      type: 'post'
    },
    {
      name: '获取系统短信配置',
      method: 'SmsConfigSystem',
      url: '/bus/api/v1/sms/config/system',
      type: 'get'
    },
    {
      name: '修改系统短信配置',
      method: 'SmsConfig',
      url: '/bus/api/v1/sms/config',
      type: 'put'
    },
    {
      name: '获取当前系统邮箱配置',
      method: 'MailSystem',
      url: '/bus/api/v1/mail/system',
      type: 'get'
    },
    {
      name: '修改当前系统邮箱配置',
      method: 'Mail',
      url: '/bus/api/v1/mail',
      type: 'put'
    },
    {
      name: '获取文件存储配置',
      method: 'FileConfigList',
      url: '/bus/api/v1/file/config/list',
      type: 'get'
    },
    {
      name: '修改文件存储配置',
      method: 'FileConfig',
      url: '/bus/api/v1/file/config',
      type: 'put'
    },
    {
      name: '写入访问量统计',
      method: 'Visit',
      url: '/bus/api/v1/visit',
      type: 'post'
    },
    {
      name: '获取操作系统访问量统计',
      method: 'VisitStatsOs',
      url: '/bus/api/v1/visit/stats/os',
      type: 'post'
    },
    {
      name: '获取浏览器访问量统计',
      method: 'VisitStatsBrowse',
      url: '/bus/api/v1/visit/stats/browse',
      type: 'post'
    },
    {
      name: '获取屏幕类型访问量统计',
      method: 'VisitStatsScreen',
      url: '/bus/api/v1/visit/stats/screen',
      type: 'post'
    },
    {
      name: '获取日访问量统计',
      method: 'VisitStatsDay',
      url: '/bus/api/v1/visit/stats/day',
      type: 'post'
    },
    {
      name: '获取菜单访问量统计',
      method: 'VisitStatsMenu',
      url: '/bus/api/v1/visit/stats/menu',
      type: 'post'
    },
    {
      name: '模块访问记录分页查询',
      method: 'VisitPaging',
      url: '/bus/api/v1/visit/paging',
      type: 'post'
    },
    {
      name: '请求发送消息',
      method: 'Message',
      url: '/bus/api/v1/message',
      type: 'post'
    },
    {
      name: '接口异常日志分页查询',
      method: 'ExceptionPaging',
      url: '/bus/api/v1/exception/paging',
      type: 'post'
    },
    {
      name: '评论信息增删改',
      method: 'CmsComment',
      url: '/bus/api/v1/cms/comment',
      type: 'post'
    },
    {
      name: '评论信息分页查询',
      method: 'CmsCommentPaging',
      url: '/bus/api/v1/cms/comment/paging',
      type: 'post'
    },
    {
      name: '评论信息审核',
      method: 'CmsCommentAudit',
      url: '/bus/api/v1/cms/comment/audit',
      type: 'put'
    },
    {
      name: '获取公众号列表',
      method: 'WechatMpAccountList',
      url: '/bus/api/v1/wechat/mp/account/list',
      type: 'get'
    },
    {
      name: '查询自定义菜单',
      method: 'WechatMpMenuList',
      url: '/bus/api/v1/wechat/mp/menu/list',
      type: 'get'
    },
    {
      name: '保存并发布菜单',
      method: 'WechatMpMenuRelease',
      url: '/bus/api/v1/wechat/mp/menu/release',
      type: 'post'
    },
    {
      name: '微信素材页码分页查询',
      method: 'WechatMpMaterialPage',
      url: '/bus/api/v1/wechat/mp/material/page',
      type: 'get'
    },
    {
      name: '上传非图文微信素材',
      method: 'WechatMpMaterialUpload',
      url: '/bus/api/v1/wechat/mp/material/upload',
      type: 'post'
    },
    {
      name: '通过id删除微信素材',
      method: 'WechatMpMaterial',
      url: '/bus/api/v1/wechat/mp/material',
      type: 'delete'
    },
    {
      name: '新增公众号',
      method: 'WechatMpAccount',
      url: '/bus/api/v1/wechat/mp/account',
      type: 'post'
    },
    {
      name: '消息自动回复分页查询',
      method: 'WechatMpReplyAutoPaging',
      url: '/bus/api/v1/wechat/mp/reply/auto/paging',
      type: 'post'
    },
    {
      name: '新增消息自动回复',
      method: 'WechatMpReplyAuto',
      url: '/bus/api/v1/wechat/mp/reply/auto',
      type: 'post'
    },
    {
      name: '公众号用户清单列表分页查询',
      method: 'WechatMpUserPaging',
      url: '/bus/api/v1/wechat/mp/user/paging',
      type: 'post'
    },
    {
      name: '同步微信用户',
      method: 'WechatMpUserSync',
      url: '/bus/api/v1/wechat/mp/user/sync',
      type: 'post'
    },
    {
      name: '修改微信备注',
      method: 'WechatMpUserRemark',
      url: '/bus/api/v1/wechat/mp/user/remark',
      type: 'put'
    },
    {
      name: '微信用户消息记录分页查询',
      method: 'WechatMpMsgList',
      url: '/bus/api/v1/wechat/mp/msg/list',
      type: 'post'
    },
    {
      name: '微信发送消息给用户',
      method: 'WechatMpMsg',
      url: '/bus/api/v1/wechat/mp/msg',
      type: 'post'
    },
    {
      name: '获取所有任务调度器',
      method: 'SchedulerInstance',
      url: '/bus/api/v1/scheduler/instance',
      type: 'post'
    },
    {
      name: '获取所有任务',
      method: 'SchedulerJob',
      url: '/bus/api/v1/scheduler/job'
    },
    {
      name: '任务控制接口',
      method: 'SchedulerJobControl',
      url: '/bus/api/v1/scheduler/job/control'
    },
    {
      name: '定时任务日志-查询全部',
      method: 'SchedulerJobLogList',
      url: '/bus/api/v1/scheduler/job/log/list',
      type: 'post'
    },
    {
      name: '获取微信用户标签字典',
      method: 'WechatMpUserTagDict',
      url: '/bus/api/v1/wechat/mp/user/tag/dict',
      type: 'get'
    },
    {
      name: '菜单资源信息-根据资源ID获取数据(增删改)',
      method: 'Resource',
      url: '/bus/api/v1/resource',
      type: 'get'
    },
    {
      name: '菜单资源信息-分页查询',
      method: 'ResourcePaging',
      url: '/bus/api/v1/resource/paging',
      type: 'post'
    },
    {
      name: '是否可以登录，权限码为 available',
      method: 'UserAvailable',
      url: '/bus/api/v1/user/available',
      type: 'put'
    },
    {
      name: '联系人管理-组织机构关联的联系人',
      method: 'UserInfoTree',
      url: '/bus/api/v1/user/info/tree',
      type: 'get'
    },
    {
      name: '联系人管理-添加联系人(删、改)',
      method: 'UserInfo',
      url: '/bus/api/v1/user/info',
      type: 'post'
    },
    {
      name: '联系人管理-获取联系人详情',
      method: 'UserInfoDetail',
      url: '/bus/api/v1/user/info/detail',
      type: 'post'
    },
    {
      name: '联系人管理-分页查询',
      method: 'UserInfoPage',
      url: '/bus/api/v1/user/info/page',
      type: 'post'
    },
    {
      name: '联系人管理-修改排序值',
      method: 'UserInfoSort',
      url: '/bus/api/v1/user/info/sort',
      type: 'put'
    }
  ]
}
